import { z } from "zod";

export enum FeedbackType {
  GeneralEHR = "generic",
  Automation = "autochart",
}

export const FeedbackSchema = z
  .object({
    title: z.string().min(1, "Title is required"),
    description: z.string().min(1, "Description is required"),
    feedbackType: z.nativeEnum(FeedbackType),
    careBlocking: z.boolean(),
    reachedOutToCODLead: z.boolean(),
    availableOnSlack: z.boolean(),
  })
  .superRefine((data, ctx) => {
    if (data.careBlocking) {
      if (!data.reachedOutToCODLead) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Please confirm you have reached out to your COD Lead",
          path: ["reachedOutToCODLead"],
        });
      }
      if (!data.availableOnSlack) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Please confirm you will be available on Slack",
          path: ["availableOnSlack"],
        });
      }
    }
  });

export type FeedbackFormValues = z.infer<typeof FeedbackSchema>;
